import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export function DashboardNewCartDialog({ open, onOpenChange, name, onNameChange, saving, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="new-cart-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">New Customer Cart</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="flex flex-col gap-3">
          <Input
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="e.g. John Smith"
            className="rounded-sm border-zinc-300"
            data-testid="new-cart-name-input"
            autoFocus
          />
          <DialogFooter className="mt-2">
            <Button
              type="submit"
              disabled={saving || !name.trim()}
              className="rounded-sm bg-blue-600 text-white hover:bg-blue-700"
              data-testid="new-cart-submit-button"
            >
              {saving ? "Creating..." : "Create"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
